<template>
  <v-card max-width="600px">
    <div class="primary pa-2" v-if="titleItem !== ''">
      <p class="white--text text-h6 font-weight-light pa-0 ma-0">
        {{ titleItem }}
      </p>
    </div>
    <v-card-title style="display: flex; justify-content: center">
      <p class="small">{{ mode }}</p>
    </v-card-title>
    <v-form
      @submit.prevent="submitForm"
      class="mx-5"
      ref="form"
      v-model="valid"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1"
      >
        {{ alertValidate }}</v-alert
      >
      <v-text-field
        name="element"
        v-model="items.element.data"
        :type="items.element.type"
        :label="items.element.label"
        :rules="items.element.rules"
        outlined
        dense
      />
      <div class="d-flex">
        <v-select
          name="dayFrom"
          :items="items.dayFrom.items"
          :item-text="items.dayFrom.itemsText"
          style="width: 50%"
          :item-value="items.dayFrom.itemsValue"
          v-model="items.dayFrom.data"
          class="mr-1"
          :label="items.dayFrom.label"
          outlined
          dense
          @change="changeFrom"
          :disabled="disabledDayFrom"
        />
        <v-menu
          ref="menuFrom"
          v-model="menuFrom"
          offset-y
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="items.timeFrom"
              name="from"
              dense
              outlined
              v-bind="attrs"
              v-on="on"
              :rules="items.from.rules"
              :label="items.from.label"
              required
              style="width: 50%"
            ></v-text-field>
          </template>
          <v-time-picker
            v-model="items.timeFrom"
            class="mt-4"
            scrollable
            format="24hr"
            :min="minFrom"
            :max="maxFrom"
            @click="$refs.menuFrom.save(items.timeFrom)"
          >
            <v-btn
              text
              color="primary"
              @click="timeFromSave(items.timeFrom)"
              class="v-picker__actions"
            >
              Aceptar
            </v-btn>
          </v-time-picker>
        </v-menu>
      </div>
      <div class="d-flex">
        <v-select
          name="dayTo"
          :items="items.dayTo.items"
          :item-text="items.dayTo.itemsText"
          style="width: 50%"
          class="mr-1"
          :item-value="items.dayTo.itemsValue"
          v-model="items.dayTo.data"
          :label="items.dayTo.label"
          outlined
          dense
          :disabled="disabledDayTo"
          @change="changeTo"
        />
        <v-menu
          ref="menuTo"
          v-model="menuTo"
          offset-y
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="items.timeTo"
              name="to"
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              :rules="items.to.rules"
              :label="items.to.label"
              required
              style="width: 50%"
            ></v-text-field>
          </template>
          <v-time-picker
            v-model="items.timeTo"
            class="mt-4"
            scrollable
            format="24hr"
            :min="minTo"
            :max="maxTo"
            @click="$refs.menuTo.save(items.timeTo)"
          >
            <v-btn
              text
              color="primary"
              @click="menuTo = false"
              class="v-picker__actions"
            >
              Aceptar
            </v-btn>
          </v-time-picker>
        </v-menu>
      </div>
      <div class="d-flex">
        <v-text-field
          v-model="items.entryTolerance.data"
          :label="items.entryTolerance.label"
          :type="items.entryTolerance.type"
          @input="timerChangeDate(items.entryTolerance)"
          maxlength="5"
          style="width: 50%"
          outlined
          dense
          class="mr-1"
          :rules="items.entryTolerance.rules"
          name="entryTolerance"
        ></v-text-field>
        <v-text-field
          v-model="items.exitTolerance.data"
          :label="items.exitTolerance.label"
          :type="items.exitTolerance.type"
          @input="timerChangeDate(items.exitTolerance)"
          maxlength="5"
          style="width: 50%"
          outlined
          dense
          class="mr-1"
          :rules="items.entryTolerance.rules"
          name="exitTolerance"
        ></v-text-field>
      </div>
      <v-select
        name="concept"
        :items="items.concept.items"
        :item-text="items.concept.itemsText"
        :item-value="items.concept.itemsValue"
        v-model="items.concept.data"
        :label="items.concept.label"
        outlined
        dense
      />
      <div class="d-flex">
        <v-text-field
          v-model="items.mts.data"
          :label="items.mts.label"
          :type="items.mts.type"
          @input="timerChangeDate(items.mts)"
          maxlength="5"
          outlined
          dense
          class="mr-3"
          :rules="items.mts.rules"
          name="mts"
        ></v-text-field>
        <v-select
          name="roundingFraction"
          class="mr-1"
          :items="items.roundingFraction.items"
          :item-text="items.roundingFraction.itemsText"
          :item-value="items.roundingFraction.itemsValue"
          v-model="items.roundingFraction.data"
          :label="items.roundingFraction.label"
          outlined
          dense
        />
        <v-text-field
          name="porcentage"
          v-model="items.porcentage.data"
          :type="items.porcentage.type"
          max="100"
          :label="items.porcentage.label"
          :rules="items.porcentage.rules"
          outlined
          dense
          suffix="%"
        />
      </div>
      <div class="d-flex justify-space-between">
        <v-checkbox
          name="labor"
          :label="items.labor.label"
          v-model="items.labor.data"
          class="my-2 pa-0"
          hide-details
        />
        <v-checkbox
          name="noHolidays"
          :label="items.noHolidays.label"
          v-model="items.noHolidays.data"
          class="my-2 pa-0"
          hide-details
        />
        <v-checkbox
          name="holidays"
          :label="items.holidays.label"
          v-model="items.holidays.data"
          class="my-2 pa-0"
          hide-details
        />
      </div>

      <div class="d-flex justify-space-between py-4">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
  </v-card>
</template>
<script>
import moment from "moment";
import schedules from "@/store/horarios/schedules";
import Vue from "vue";

export default {
  props: {
    mode: String,
    itemsElement: Object,
    titleItem: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      items: {},
      valid: true,
      error: false,
      alertValidate: "",
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      menuFrom: false,
      menuTo: false,
      maxFrom: "23:59",
      minFrom: "00:00",
      maxTo: "23:59",
      minTo: "00:00",
      disabledDayTo: false,
      disabledDayFrom: false,
    };
  },

  mounted() {
    this.items = Vue.observable(this.itemsElement);
  },
  watch: {
    itemsElement: {
      immediate: true,
      handler(value) {
        this.items = value;
      },
    },
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.handleSubmit(e.target);
    },
    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.itemsParse(itemsComplete);
    },
    cancel() {
      this.disabledDayFrom = false;
      this.disabledDayTo = false;
      this.$refs.form.resetValidation();
      this.$emit("cancel", false);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        if (form.from > form.to && form.dayFrom == form.dayTo) {
          this.error = true;
          this.alertValidate = this.$tc("schedules.errorhs");
          this.alertError();
        } else {
          this.$emit("save", form);
          setTimeout(() => {
            this.cancel();
          }, 500);
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        this.alertError();
      }
    },
    itemsParse(form) {
      let noHolidays = form.noHolidays == "" ? true : false;
      let holidays = form.holidays == "" ? true : false;
      let labor = form.labor == "" ? true : false;
      const mts = this.convertToMinutes(form.mts);
      const entry = this.convertToMinutes(form.entryTolerance);
      const exit = this.convertToMinutes(form.exitTolerance);
      const fromValue = this.convertToMinutes(form.from, form.dayFrom);
      const toValue = this.convertToMinutes(form.to, form.dayTo);
      let concept =
        form.concept == "[object Object]" ? 2 : parseInt(form.concept, 10);
      let conceptName = this.items.concept.items.find(
        (item) => item.id == concept
      );

      let payload = {
        mts: mts,
        concept: concept,
        conceptName: conceptName.name,
        dayFrom: parseInt(form.dayFrom, 10),
        dayTo: parseInt(form.dayTo, 10),
        element: form.element,
        entry: entry,
        exit: exit,
        from: fromValue,
        to: toValue,
        porcentage: parseInt(form.porcentage, 10),
        roundingFraction: parseInt(form.roundingFraction, 10),
        noHolidays: noHolidays,
        holidays: holidays,
        labor: labor,
        segid: schedules.state.segmentId,
      };
      this.validation(payload);
    },
    convertToMinutes(value, dayValue) {
      const [hours, minutes] = value.split(":");
      const hoursInt = parseInt(hours, 10);
      const minutesInt = parseInt(minutes, 10);
      let totalMinutes = hoursInt * 60 + minutesInt;
      if (dayValue === "0") {
        totalMinutes -= 1440;
      } else if (dayValue === "2") {
        totalMinutes += 1440;
      }
      return totalMinutes;
    },
    timerChangeDate(input) {
      let data = input.data;

      if (data === "") {
        data = "00:10";
      } else if (!/^[0-9:]+$/.test(data)) {
        data = "00:00";
      } else {
        data = data.replace(/[^\d:]/g, "");
        if (data.length >= 2 && data.indexOf(":") === -1) {
          data = data.substring(0, 2) + ":" + data.substring(2);
        }

        data = data.substring(0, 5);
        const [horas, minutos] = data.split(":").map(Number);

        if (!isNaN(minutos) && minutos > 59) {
          data = `${horas}:59`;
        }
        if (!isNaN(horas) && horas > 12) {
          data = "12:00";
        } else if (horas === 12 && minutos > 0) {
          data = "12:00";
        }
      }
      input.data = data;
    },

    alertError() {
      setTimeout(() => {
        this.error = false;
      }, 2500);
    },
    changeTo(event) {
      this.items.timeTo = null;
      if (event == 2) {
        this.maxTo = "11:59";
        this.minTo = "00:00";
      }
    },
    changeFrom(event) {
      this.items.timeFrom = null;
      switch (event) {
        case 0:
          this.maxFrom = "23:59";
          this.minFrom = "12:00";
          this.disabledDayTo = true;
          this.items.dayTo.data = 1;
          this.items.timeTo = null;

          break;
        case 1:
          this.disabledDayTo = false;
          this.maxFrom = "23:59";
          this.minFrom = "00:00";
          this.items.timeTo = null;
          break;
        case 2:
          this.disabledDayTo = true;
          this.items.dayTo.data = 2;
          this.maxFrom = "11:59";
          this.minFrom = "00:00";
          this.items.timeTo = null;

          break;
        default:
          break;
      }
    },
    timeFromSave(time) {
      this.menuFrom = false;
      const momentTime = moment(time, "HH:mm");
      const duration = moment.duration(12, "hours");
      const newTime = momentTime.add(duration).format("HH:mm");
      switch (this.items.dayFrom.data) {
        case 0:
          this.minTo = "00:00";
          this.maxTo = newTime;
          break;

        case 2:
          this.minTo = time;
          this.maxTo = newTime;
          break;
      }
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.small {
  font-size: x-large;
}
</style>
